import React, { useState,useEffect } from 'react';
import SetupScreen from './components/SetupScreen';
import InterviewRoom from './components/InterviewRoom';
import HistoryScreen from './components/HistoryScreen';
import PaymentSuccess from './components/PaymentSuccess';  // ← this line is missing


import { useLocalStorage } from './hooks/useLocalStorage';
import './App.css';

export default function App() {
  const [screen, setScreen] = useState('setup'); // setup | interview
  const [sessionData, setSessionData] = useState(null);
  const [config, setConfig] = useState(null);

  // Persist userId + userStatus across page refreshes
  const [savedUser, setSavedUser, clearSavedUser] = useLocalStorage('aria_user', null);

  // ── Detect Cashfree return redirect ──
  useEffect(() => {
    const path = window.location.pathname;
    if (path === '/payment/success') {
      setScreen('payment-success');
    }
  }, []);

  const handleStart = (cfg, data) => {
    setConfig(cfg);
    setSessionData(data);
    setScreen('interview');
  };

  const handleRestart = () => {
    setScreen('setup');
    setSessionData(null);
    setConfig(null);
  };

  const handleViewHistory = () => setScreen('history');
  const handleBackFromHistory = () => setScreen('setup');

  // Called after payment verified successfully
  const handlePaymentSuccess = (updatedUser) => {
    setSavedUser(updatedUser);
    // Clear URL params and go back to setup
    window.history.replaceState({}, '', '/');
    setScreen('setup');
  };


  const handlePaymentFailure = () => {
    window.history.replaceState({}, '', '/');
    setScreen('setup');
  };

  const handleLogout = () => {
    clearSavedUser();      // clears localStorage
    setScreen('setup');    // go back to setup
    setSessionData(null);  // clear any session
    setConfig(null);
  };

  return (
    <div className="app-root">
      {screen === 'setup' && (
        <SetupScreen
          key={savedUser?.userId || 'guest'}  
          onStart={handleStart}
          savedUser={savedUser}
          onSaveUser={setSavedUser}
          onViewHistory={handleViewHistory}
          onLogout={handleLogout}
        />
      )}
      {screen === 'interview' && (
        <InterviewRoom
    sessionData={sessionData}
    config={config}
    onRestart={handleRestart}
    onUpgrade={() => {          // ← add this
      setScreen('setup');
      setSessionData(null);
      setConfig(null);
    }}
  />
      )}
      {screen === 'history' && (
        <HistoryScreen
          userId={savedUser?.userId}
          onBack={handleBackFromHistory}
        />
      )}
      {screen === 'payment-success' && (
        <PaymentSuccess
          onSuccess={handlePaymentSuccess}
          onFailure={handlePaymentFailure}
        />
      )}
    </div>
  );
}
